import {PatientDataModel} from '../../models/patient/patient-data.model';
import {ContactDataModel} from '../../models/person/contact-data.model';

export class PatientDialogDataModel {
  static readonly MODE_NEW_PATIENT = 'NewPatient';
  static readonly MODE_EDIT_PATIENT = 'EditPatient';
  static readonly MODE_NEW_CONTACT = 'NewContact';
  static readonly MODE_EDIT_CONTACT = 'EditContact';

  static readonly TYPE_DOCTOR = 'doctor';
  static readonly TYPE_PATIENT = 'patient';
  static readonly TYPE_USER = 'user';
  static readonly TYPE_ORGANIZATION = 'organization';

  mode: string;
  ThePatient: PatientDataModel;
  ThePatientToCopy: PatientDataModel;
  TheContact: ContactDataModel;
  title: string;
  //initWebId: boolean;
  saveSoloContact: boolean;
  loadPatient: boolean;
  patientId: string;
  entityType: string = 'patient';
  doctorId: string;
  contacts: ContactDataModel[];
  itemName: string;
  isReferralPatient: boolean;
  // entityId can be patientId, doctorId, userId, etc.  It will be checked against type.
  entity: any;
  entityId: string;
  // insurance card info - used from referral management
  insuranceCardInfo: string;
}
